import { stringify } from 'qs';
import { SearchParams } from './NavigationUtil';

export const getImageSrcset = (sizes: string[], url: string) => {
  return sizes.map((size) => cloudinaryUrlWithSize(size, url, true)).join(',');
};

export const getCroppedImageSrcset = (
  crop: { width: string; height: string; heightOffset: string; gravity: string },
  sizes: string[],
  url: string,
  isShop: boolean
) => {
  return sizes.map((size) => cloudinaryUrlWithSizeCropped(crop, size, url, true, isShop)).join(',');
};

const preprocessCloudinaryUrl = (url: string, isShop: boolean) => {
  ['http', 'https'].forEach((protocol) => {
    if (url.includes(`${protocol}://res.cloudinary.com/${isShop ? 'telia-pim' : 'telia'}/image/upload/`)) {
      url = url.replace(`${protocol}://res.cloudinary.com/${isShop ? 'telia-pim' : 'telia'}/image/upload/`, '');
    }
  });
  if (url.startsWith('/upload')) {
    url = url.substr('/upload'.length + 1);
  }
  return url;
};

const getCloudinaryUrl = (protocol: string, env: string) => {
  return `${protocol}://res.cloudinary.com/${env}/image/upload/`;
};

export const cloudinaryUrlWithSize = (size: string, url: string, srcSet: boolean): string => {
  if (!url) {
    return '';
  }
  let imageLocation = 'telia-pim';
  ['http', 'https'].forEach((protocol) => {
    if (url.includes(getCloudinaryUrl(protocol, 'telia-pim'))) {
      url = url.replace(getCloudinaryUrl(protocol, 'telia-pim'), '');
    } else if (url.includes(getCloudinaryUrl(protocol, 'telia'))) {
      url = url.replace(getCloudinaryUrl(protocol, 'telia'), '');
      imageLocation = 'telia';
    } else if (url.includes(getCloudinaryUrl(protocol, 'telia-dev'))) {
      url = url.replace(getCloudinaryUrl(protocol, 'telia-dev'), '');
      imageLocation = 'telia-dev';
    } else if (url.includes(getCloudinaryUrl(protocol, 'telia-test'))) {
      url = url.replace(getCloudinaryUrl(protocol, 'telia-test'), '');
      imageLocation = 'telia-test';
    }
  });
  if (url.startsWith('/upload')) {
    url = url.substr('/upload'.length + 1);
  }
  return `https://res.cloudinary.com/${imageLocation}/image/upload/f_auto,fl_lossy,q_auto:best,w_${size}/${url}${srcSet ? ` ${size}w` : ''}`;
};

export const cloudinaryUrlWithSizeCropped = (
  crop: { width: string; height: string; heightOffset: string; gravity: string },
  size: string,
  url: string,
  srcSet: boolean,
  isShop: boolean
): string => {
  if (!url) {
    return '';
  }
  url = preprocessCloudinaryUrl(url, isShop);
  return `https://res.cloudinary.com/${isShop ? 'telia-pim' : 'telia'}/image/upload/f_auto,fl_lossy,q_auto:best,c_crop,${crop.gravity},w_${crop.width},h_${
    crop.height
  },y_${crop.heightOffset}/${url}${srcSet ? ` ${size}w` : ''}`;
};

export const createParamsString = (params: SearchParams): string => stringify(params, { addQueryPrefix: true, arrayFormat: 'repeat' });

export const removeTrailingSlash = (value: string): string => {
  return value.replace(/\/$/, '');
};
